var map = {
	"./Cerchio": [
		225,
		225
	],
	"./Cerchio.js": [
		225,
		225
	],
	"./FlazioComponent": [
		657
	],
	"./FlazioComponent.js": [
		657
	],
	"./Immagine": [
		153,
		87,
		153
	],
	"./Immagine.js": [
		153,
		87,
		153
	],
	"./Immaginesingola": [
		401,
		87,
		401
	],
	"./Immaginesingola.js": [
		401,
		87,
		401
	],
	"./Orizzontalemenu": [
		440,
		440
	],
	"./Orizzontalemenu.js": [
		440,
		440
	],
	"./Pulsante": [
		895,
		895
	],
	"./Pulsante.js": [
		895,
		895
	],
	"./Rettangolo": [
		442,
		442
	],
	"./Rettangolo.js": [
		442,
		442
	],
	"./Testo": [
		399,
		399
	],
	"./Testo.js": [
		399,
		399
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 413;
module.exports = webpackAsyncContext;